import { render, staticRenderFns } from "./TooltipChip.vue?vue&type=template&id=4b7bd556"
import script from "./TooltipChip.vue?vue&type=script&lang=js"
export * from "./TooltipChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports